module.exports = __webpack_public_path__ + "static/img/zainEsports.81e94b1a.webp";